import { ScaleElement } from '@scale/base-element';
import { CartAPI } from '@scale/cart-api';
import { getCartSections } from '@scale/utilities';

class QuickAdd extends ScaleElement {
  #variantId;
  #adding = false;
  #resetTimer;

  setup() {
    this.#variantId = this.getAttribute('data-variant-id');

    this.on('click', (e) => {
      if (e.target.closest('[data-ref="btn"]')) {
        e.stopPropagation();
        this.#addToCart();
      }
    });
  }

  teardown() {
    clearTimeout(this.#resetTimer);
  }

  async #addToCart() {
    if (this.hasAttribute('data-sold-out') || !this.#variantId || this.#adding) return;

    const button = this.ref('btn');
    this.#adding = true;
    clearTimeout(this.#resetTimer);
    this.ref('reason').hidden = true;
    button.setAttribute('aria-busy', 'true');
    button.dataset.state = 'loading';

    try {
      await CartAPI.add([{ id: Number(this.#variantId), quantity: 1 }], {
        sections: getCartSections(),
        target: this,
        context: this.closest('dialog') ? 'dialog' : 'product',
      });
      this.#show('added', 1500);
    } catch (error) {
      if (error.name === 'AbortError') {
        delete button.dataset.state;
        return;
      }
      const reason = this.ref('reason');
      reason.textContent = error.message;
      reason.hidden = false;
      this.announce(error.message, 'assertive');
      this.#show('refused', 4000);
    } finally {
      this.#adding = false;
      button.removeAttribute('aria-busy');
    }
  }

  #show(state, duration) {
    const button = this.ref('btn');
    button.dataset.state = state;
    this.#resetTimer = setTimeout(() => {
      delete button.dataset.state;
      this.ref('reason').hidden = true;
    }, duration);
  }
}

if (!customElements.get('scale-quick-add')) {
  customElements.define('scale-quick-add', QuickAdd);
}
